/**
 * @description Open share link in new window popup, instead of new tab (in which the time of edit)
 *
 * @see /resources/views/components/sharingPanel.blade.php
 */
import {openAsWindow} from '../modules/windowOpener.js';
import './copyToClipboard.js';

const activatedInstances = [];

/**
 * Listener when share link has being clicked
 * @param {Event} clickEvent
 */
let onLinkClicked = (clickEvent) => {
    /** @type {HTMLAnchorElement} */
    const anchor = clickEvent.currentTarget;
    const url = anchor.getAttribute('href');
    const target = anchor.getAttribute('target');

    if (url && target === '_blank') {
        clickEvent.preventDefault();

        openAsWindow(url);
    }

    anchor.dispatchEvent(new CustomEvent('dev:metric', {
        detail: {
            category: 'sharingPanel',
            action: 'click',
            type: anchor.title || 'Unknown button',
        },
        bubbles: true,
    }));
};

/**
 * Implement all the share link to open as a new window
 * as user click on it
 */
const openShareLinkAsNewWindow = () => {
    let shareLinks = [...document.querySelectorAll('.js-shareLink')];
    shareLinks.forEach((anchor) => {
        if (!activatedInstances.includes(anchor)) {
            anchor.addEventListener('click', onLinkClicked);
        }
    });
};

document.readyState === 'loading'
    ? new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, {once: true})).then(openShareLinkAsNewWindow)
    : openShareLinkAsNewWindow();
